import axios from 'axios'
import { makeQueryString } from '@/utils/Query.js'
const API_BASE_URL = process.env.VUE_APP_API_URL;

const config = {
    baseUrl: API_BASE_URL + "/homepage/startup/"
};

const startupAPIDFN = {
    startupAPI: (APIName, conditions, paths) => {
        return startupAPI[APIName](conditions, paths);
    }
};

const startupAPI = {
    API_BASE_URL: `${API_BASE_URL}`,
    selectGs25Faq: (conditions, paths) => {
        const uri = paths || "gs25startup/selectGs25Faq"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectBestGs25Faq: (conditions, paths) => {
        const uri = paths || "gs25startup/selectBestGs25Faq"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    insertGs25BriefingSessionRequest: (conditions, paths) => {
        const uri = paths || "gs25startup/insertGs25BriefingSessionRequest"
        return axios.post(`${config.baseUrl}${uri}`, conditions);
    },
    selectGs25BriefingSession: (conditions, paths) => {
        const uri = paths || "gs25startup/selectGs25BriefingSession"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getGs25BriefingSession: (conditions, paths) => {
        const uri = paths || "gs25startup/getGs25BriefingSession"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectGs25Consultant: (conditions, paths) => {
        const uri = paths || "gs25startup/selectGs25Consultant"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectGs25ConsultantNonPaging: (conditions, paths) => {
        const uri = paths || "gs25startup/selectGs25ConsultantNonPaging"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectGs25NewStoreConsultant: (conditions, paths) => {
        const uri = paths || "gs25startup/selectGs25NewStoreConsultant"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectGs25NewStoreRegion: (conditions, paths) => {
        const uri = paths || "gs25startup/selectGs25NewStoreRegion"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getGs25Consultant: (conditions, paths) => {
        const uri = paths || "gs25startup/getGs25Consultant"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    insertGs25StartupConsultationRequest: (conditions, paths) => {
        const uri = paths || "gs25startup/insertGs25StartupConsultationRequest"
        return axios.post(`${config.baseUrl}${uri}`, conditions);
    },
    getGs25Faq: (conditions, paths) => {
        const uri = paths || "gs25startup/getGs25Faq"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectGs25RecommendStore: (conditions, paths) => {
        const uri = paths || "gs25startup/selectGs25RecommendStore"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getGs25RecommendStore: (conditions, paths) => {
        const uri = paths || "gs25startup/getGs25RecommendStore"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    insertGs25SwitchConsultationRequest: (conditions, paths) => {
        const uri = paths || "gs25startup/insertGs25SwitchConsultationRequest"
        return axios.post(`${config.baseUrl}${uri}`, conditions);
    },
    selectGs25PsnSchedule: (conditions, paths) => {
        const uri = paths || "gs25startup/selectGs25PsnSchedule"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    insertGtfBriefingSessionRequest: (conditions, paths) => {
        const uri = paths || "gtfstartup/insertGtfBriefingSessionRequest"
        return axios.post(`${config.baseUrl}${uri}`, conditions);
    },
    selectGtfBriefingSession: (conditions, paths) => {
        const uri = paths || "gtfstartup/selectGtfBriefingSession"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getGtfBriefingSession: (conditions, paths) => {
        const uri = paths || "gtfstartup/getGtfBriefingSession"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectGtfConsultant: (conditions, paths) => {
        const uri = paths || "gtfstartup/selectGtfConsultant"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getGtfConsultant: (conditions, paths) => {
        const uri = paths || "gtfstartup/getGtfConsultant"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    insertGtfStartupConsultationRequest: (conditions, paths) => {
        const uri = paths || "gtfstartup/insertGtfStartupConsultationRequest"
        return axios.post(`${config.baseUrl}${uri}`, conditions);
    },
    insertLocationProposal: (conditions, paths) => {
        const uri = paths || "gtfstartup/insertLocationProposal"
        return axios.post(`${config.baseUrl}${uri}`, conditions);
    },
    selectGtfFaq: (conditions, paths) => {
        const uri = paths || "gtfstartup/selectGtfFaq"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getGtfFaq: (conditions, paths) => {
        const uri = paths || "gtfstartup/getGtfFaq"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectGtfRecommendStore: (conditions, paths) => {
        const uri = paths || "gtfstartup/selectGtfRecommendStore"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getGtfRecommendStore: (conditions, paths) => {
        const uri = paths || "gtfstartup/getGtfRecommendStore"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
};

export { startupAPIDFN, startupAPI };
